import { ConnectedRouter } from 'connected-react-router';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Provider, ReactReduxContext } from 'react-redux';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Provider as UnstatedProvider } from 'unstated';

import { GraphqlProvider } from '@confluence/graphql-provider/entry-points/graphqlProvider.ts';

import { ConnectSupport } from '@confluence/connect-support';
import { ConfluenceAnalyticsListener } from '@confluence/analytics/entry-points/analyticsListener.ts';
import { getBrowserHistory } from '@confluence/browser-history';
import { UpFlowProvider } from '@confluence/change-edition/entry-points/UpFlowProvider.ts';
import { Dialogs } from '@confluence/dialogs/entry-points/Dialogs.ts';
import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { getExperienceTracker } from '@confluence/experience-tracker/entry-points/getExperienceTracker.ts';
import { Flags } from '@confluence/flags/entry-points/Flags.ts';
import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient.ts';
import { I18nProvider } from '@confluence/i18n/entry-points/I18nProvider.ts';
import { namedRoutes } from '@confluence/named-routes/entry-points/named-routes.ts';
import { NavdexListener } from '@confluence/navdex/entry-points/NavdexListener.tsx';
import { RouteManager } from '@confluence/route-manager/entry-points/RouteManager.ts';
import { SPAViewContextProvider } from '@confluence/spa-view-context/entry-points/SPAViewContext.ts';
import { getStandalonePageTreeStateUpdater } from '@confluence/page-tree-refresh-state-container/entry-points/getStandalonePageTreeStateUpdater.ts';

import { EngagementProvider } from '../EngagementProvider/index.ts';

/**
 * This component is responsible for bootstrapping navigation for legacy server rendered page.
 * Also it bootstraps React Component in legacy location like inline comment body.
 */
export default class ComponentWrapper extends Component {
	static propTypes = {
		/**
		 * Global store
		 */
		store: PropTypes.object.isRequired,
		/**
		 * Children Component
		 */
		children: PropTypes.any,
		/**
		 * Indicates if the component is rendered as Root
		 */
		renderAsRoot: PropTypes.bool,
	};

	browserHistory = getBrowserHistory();

	render() {
		const { store } = this.props;
		return (
			<UnstatedProvider inject={[getStandalonePageTreeStateUpdater()]}>
				<GraphqlProvider client={getApolloClient()}>
					<Provider store={store}>
						<SPAViewContextProvider>
							<ExperienceTrackerContext.Provider value={getExperienceTracker()}>
								<I18nProvider>
									<ConfluenceAnalyticsListener>
										<NavdexListener>
											<EngagementProvider>
												<ConnectedRouter history={this.browserHistory} context={ReactReduxContext}>
													<UpFlowProvider>
														<Flags />
														<ConnectSupport />
														<RouteManager namedRoutes={namedRoutes}>
															<Dialogs />
															{this.props.children}
														</RouteManager>
													</UpFlowProvider>
												</ConnectedRouter>
											</EngagementProvider>
										</NavdexListener>
									</ConfluenceAnalyticsListener>
								</I18nProvider>
							</ExperienceTrackerContext.Provider>
						</SPAViewContextProvider>
					</Provider>
				</GraphqlProvider>
			</UnstatedProvider>
		);
	}
}
